import { useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation } from "@apollo/client";
import dayjs from "dayjs";

import Button from "components/Button";
import Textarea from "components/Textarea";
import { parseError } from "helpers/convertFormData";
import { showErrorMessage } from "helpers/toastMessage";
import { ILoadQuestion } from "models/Load";
import { MUTATION_CREATE_LOAD_ANSWER } from "../../Detail/query";
import styles from "./style.module.scss";

interface IProps {
  loadQuestion: ILoadQuestion[];
  goToUserProfile: (id: string) => void;
  refresh?: VoidFunction;
  isMyLoad?: boolean;
}

export default function LoadQuestion({
  loadQuestion,
  goToUserProfile,
  refresh,
  isMyLoad = false
}: Readonly<IProps>) {
  const { loadId } = useParams();
  const [newAnswers, setNewAnswers] = useState<any>();

  const [CreateAnswer] = useMutation(MUTATION_CREATE_LOAD_ANSWER, {
    onError(err) {
      err.graphQLErrors.map(({ message }) => showErrorMessage(parseError(message)));
    }
  });

  const sendLoadAnswer = async (questionId: string) => {
    try {
      await CreateAnswer({
        variables: {
          loadId: loadId,
          questionId: questionId,
          answer: newAnswers[questionId] || ""
        }
      });
      refresh && refresh();
    } catch (error) {
      showErrorMessage("Failed to answer question.");
    }

    setNewAnswers((prev: any) => ({ ...prev, [questionId]: "" }));
  };

  const handleChange = (questionId: string, value: string) => {
    setNewAnswers((prev: any) => ({ ...prev, [questionId]: value }));
  };

  return (
    <ul className={styles.questionList}>
      {loadQuestion.map((loadQuestion) => (
        <li key={loadQuestion.id}>
          <div className={styles.question}>
            <div className={styles.item}>
              <div className={styles.headerIcon}>
                <span className="text-lg">Q</span>
                <span className="text-xs text-center">
                  {dayjs(loadQuestion.timePosted).format("MM/DD/YY HH:mm")}
                </span>
              </div>
              <p className="text-sm">{loadQuestion.question}</p>
            </div>
            {loadQuestion.user ? (
              <button
                type="button"
                className="text-xs text-info"
                onClick={() => goToUserProfile(loadQuestion.user)}>
                View Profile
              </button>
            ) : null}
          </div>
          {loadQuestion.answerSet.length === 0 && isMyLoad ? (
            <div className={styles.loadDetailSend}>
              <Textarea
                onChange={(e) => handleChange(loadQuestion.id, e.target.value)}
                className="flex-1"
                placeholder="Type your answer here..."
              />
              <Button
                className={styles.loadDetailSendButton}
                onClick={() => sendLoadAnswer(loadQuestion.id)}>
                Send
              </Button>
            </div>
          ) : (
            <>
              {loadQuestion.answerSet.map((loadAnswer) => (
                <div key={loadAnswer.id} className={styles.answerWrapper}>
                  <div className={styles.header}>
                    <span className="text-lg">A</span>
                    <span className="text-xs text-center">
                      {dayjs(loadAnswer.timePosted).format("MM/DD/YY HH:mm")}
                    </span>
                  </div>
                  <p className="text-sm">{loadAnswer.answer}</p>
                </div>
              ))}
            </>
          )}
        </li>
      ))}
    </ul>
  );
}
